const GridColDefs = [
    {id: 'ticketKey', title: 'Ticket Key'},
    {id: 'dateHour', title: 'Data/Hora'},
    {id: 'ticketStatus', title: 'Estado do Ticket'},
    {id: 'vin', title: 'Nº de Chassis'},
    {id: 'marca', title: 'Marca'},
    {id: 'licenseNumber', title: 'Matrícula'},
    {id: 'dealerName', title: 'Dealer'},
    {id: 'tuga', title: 'Existe no Tuga?'},
    {id: 'blockFromTspReason', title: 'Bloqueado ao TSP?'},
    {id: 'receiveStatusDescription', title: 'Estado de receção'},
];

export default GridColDefs;
